import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Box, Grid, Paper } from '@mui/material';
import SubmissionForm from '../SubmissionForm';
import FlashMessage from '../FlashMessage';
import VerificationPage from './VerificationPage';
import EmailVerificationPage from './EmailVerificationPage';
import ThanksPage from './ThanksPage';
import TrackSubmissionPage from './TrackSubmissionPage';
import TermsAndConditionsPage from './TermsAndConditionsPage';
import PrivacyPolicyPage from './PrivacyPolicyPage';
import FAQPage from './FAQPage';
import ContactUsPage from './ContactUsPage';
import CustomTabPage from './CustomTabPage';
import HowItWorksPage from './HowItWorksPage';
import UpdateClaimPage from './UpdateClaimPage';
import UpdateThanksPage from './UpdateThanksPage';
import UnsubscribePage from './UnsubscribePage';

export class PromoContentPage extends React.Component {
  templateComponent(customTab) {
    const { promotion } = this.props;

    if (customTab.template == 'how_it_works') {
      return <HowItWorksPage promotion={promotion} label={customTab.label} content={customTab.content} />
    }
  }

  render() {
    const { promotion } = this.props;

    return (
      <React.Fragment>
        <div className="promo-banner background" role="img" title={promotion.banner_background_alt_text || "Promo banner background"} style={{'backgroundImage': 'url("' + promotion.banner_background + '")'}}></div>
        <Grid className="form-grid" size={{xs: 10, md: 5}} justifyContent="center">
          <Paper className="form-container" elevation={1}>
            <FlashMessage />
            <Switch>
              <Route path="/terms" render={() => <TermsAndConditionsPage promotion={promotion} content={promotion.terms_and_conditions.content} />} />
              <Route path="/privacy_policy" render={() => <PrivacyPolicyPage promotion={promotion} content={promotion.privacy_policy.content} />} />
              <Route path="/faq" render={() => <FAQPage promotion={promotion} content={promotion.faqs.content} />} />
              {promotion.trackable &&
                <Route path="/track" render={() => <TrackSubmissionPage promotion_id={promotion.id} />} />
              }
              {promotion.custom_tabs.map((custom_tab, index) =>
                custom_tab.template ?
                  <Route key={index} path={"/" + custom_tab.path} render={() => this.templateComponent(custom_tab)} />
                :
                  <Route key={index} path={"/" + custom_tab.path} render={() => <CustomTabPage promotion={promotion} content={custom_tab.content} label={custom_tab.label} />} />
              )}
              <Route path="/contact" render={() => <ContactUsPage promotion={promotion} />} />
              <Route path="/verify_email" render={() => <EmailVerificationPage promotion={promotion} />} />
              <Route path="/verify" render={() => <VerificationPage promotion={promotion} />} />
              <Route path="/thanks" render={() => <ThanksPage promotion={promotion} />} />
              <Route path="/update_claim" render={() => <UpdateClaimPage promotion={promotion} />} />
              <Route path="/update_success" render={() => <UpdateThanksPage promotion={promotion} />} />
              <Route path="/unsubscribes" render={() => <UnsubscribePage promotion={promotion} />} />
              <Route path="/claim" render={() => <SubmissionForm promotion={promotion} />} />
            </Switch>
          </Paper>
        </Grid>
      </React.Fragment>
    )
  }
}

export default withRouter(PromoContentPage);
